import { render } from "./verify-email.vue?vue&type=template&id=742fd4af"
import script from "./verify-email.vue?vue&type=script&lang=js"
export * from "./verify-email.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__